<template>
  <div>
    <v-card color="#eceff1" flat>
      <v-card-title>
        <v-icon left>mdi-alert-circle</v-icon>
        Errores de Procesamiento
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <span v-if="errores.length > 0" class="text-subtitle-1 mr-3">
            Total: {{ errores.length }} error(es)
          </span>
          <v-btn
            v-if="errores.length > 0"
            color="primary"
            small
            @click="descargarCSV"
            :loading="descargandoCSV"
          >
            <v-icon left small>mdi-download</v-icon>
            Descargar CSV
          </v-btn>
        </div>
      </v-card-title>
      
      <v-card-text v-if="errores.length === 0 && !loading">
        <v-alert type="success" outlined>
          <v-icon slot="prepend">mdi-check-circle</v-icon>
          No se encontraron errores en los procesamientos.
        </v-alert>
      </v-card-text>

      <v-card-text v-if="loading">
        <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
      </v-card-text>

      <v-card-text v-if="errores.length > 0">
        <v-data-table
          :headers="headers"
          :items="errores"
          :loading="loading"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Filas por página:'
          }"
        >
          <template slot="item.procesamientoArchivoId" slot-scope="{ item }">
            <v-chip small color="primary" text-color="white">
              {{ item.procesamientoArchivoId }}
            </v-chip>
          </template>
          
          <template slot="item.fila" slot-scope="{ item }">
            <v-chip small color="orange" text-color="white">
              Fila {{ item.fila }}
            </v-chip>
          </template>
          
          <template slot="item.columna" slot-scope="{ item }">
            <v-chip 
              v-if="item.columna" 
              small 
              color="blue" 
              text-color="white"
            >
              {{ item.columna }}
            </v-chip>
            <span v-else class="text--disabled">N/A</span>
          </template>

          <template slot="item.mensaje" slot-scope="{ item }">
            <div class="error-message">
              {{ item.mensaje }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    errores: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      descargandoCSV: false,
      headers: [
        { 
          text: 'ID Procesamiento', 
          value: 'procesamientoArchivoId',
          width: '150px'
        },
        { 
          text: 'Fila', 
          value: 'fila',
          width: '100px'
        },
        { 
          text: 'Columna', 
          value: 'columna',
          width: '120px'
        },
        { 
          text: 'Mensaje', 
          value: 'mensaje',
          sortable: false
        }
      ]
    };
  },

  methods: {
    descargarCSV() {
      try {
        this.descargandoCSV = true;
        
        // Define CSV headers
        const csvHeaders = [
          'ID Procesamiento',
          'Fila',
          'Columna',
          'Mensaje'
        ];
        
        // Convert data to CSV format
        const csvData = this.errores.map(error => [
          error.procesamientoArchivoId || '',
          error.fila || '',
          error.columna || 'N/A',
          `"${(error.mensaje || '').replace(/"/g, '""')}"` // Escape quotes in message
        ]);
        
        // Combine headers and data
        const csvContent = [
          csvHeaders.join(','),
          ...csvData.map(row => row.join(','))
        ].join('\n');
        
        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          
          // Generate filename with current date
          const now = new Date();
          const fecha = now.toISOString().split('T')[0]; // YYYY-MM-DD format
          const hora = now.toTimeString().split(' ')[0].replace(/:/g, '-'); // HH-MM-SS format
          const fileName = `errores_procesamiento_marcacion_${fecha}_${hora}.csv`;
          
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up the URL object
          URL.revokeObjectURL(url);
          
          // Show success message
          this.$toast?.success?.(`Archivo CSV descargado: ${fileName}`) || 
          console.log(`Archivo CSV descargado: ${fileName}`);
        }
      } catch (error) {
        console.error('Error al descargar CSV:', error);
        this.$toast?.error?.('Error al generar el archivo CSV') || 
        console.error('Error al generar el archivo CSV');
      } finally {
        this.descargandoCSV = false;
      }
    }
  }
};
</script>

<style scoped>
.error-message {
  word-break: break-word;
  white-space: normal;
  max-width: 400px;
}
</style>